import { useEffect, useState } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

function Privacy() {
  const [privacyText, setPrivacyText] = useState('');

  useEffect(() => {
    fetch('/02_privacy.txt')
      .then((r) => r.text())
      .then(setPrivacyText)
      .catch((e) => console.error('Error loading privacy text:', e));
  }, []);

  return (
    <div style={styles.wrapper}>
      <div style={styles.card}>
        {privacyText ? (
          <div style={styles.markdown}>
            <ReactMarkdown remarkPlugins={[remarkGfm]}>
              {privacyText}
            </ReactMarkdown>
          </div>
        ) : (
          <p>Loading…</p>
        )}
      </div>
    </div>
  );
}

const styles = {
  wrapper: {
    height: '100vh',
    background: 'linear-gradient(135deg, #e6fffa, #ffffff)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontFamily: "'Segoe UI', sans-serif",
    paddingBottom: '4rem', // room for footer
  },
  card: {
    background: 'white',
    padding: '3rem',
    borderRadius: '16px',
    boxShadow: '0 12px 28px rgba(0,0,0,0.1)',
    textAlign: 'left',
    maxWidth: '700px',
    width: '100%',
    overflowY: 'auto',
    maxHeight: '80vh',
  },
  title: { fontSize: '2rem', color: '#234e52', marginBottom: '1rem', textAlign: 'center' },
  markdown: { color: '#2d3748', lineHeight: 1.7 },
};

export default Privacy;
